import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {accountingReportByUser_template} from "../components/templates/accountingReportByUser_template";
import {downloadCSV} from "../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";
import {header} from "./header";

declare var ko: any;
declare var page: any;
export class accounting_report_by_user extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlDeletedTable: XMLHttpRequestHandler;
    protected listTemplate: accountingReportByUser_template;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdlsKeys: string[] =['getReportData', 'getReportDataCount',  'getReportDataForExport', 'getReportDataBreakout'];
    protected nbQueries: number = this.XHRHdlsKeys.length;
    protected nbReturnedQueries: number = 0;
    protected queryStartTime: number = 0;

    protected getModuleName() {
        return "accounting_report_by_user";
    }

    buildContent(): Array<Element> {
        this.listTemplate = new accountingReportByUser_template("list", this.viewModel, this);
        this.template = this.listTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;

        (<header>loadedModule).setHeaderTitle("Transaction Overview");
        return [this.listTemplate.build()];
    }

    public fillPage(): void {

        let vnApp = this.getVnAppZone().app;
        if(vnApp.loggedUser != null && vnApp.loggedUser.isLoggedIn) {
            this.getfilterReference();
        }
    }

    protected getfilterReference() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string;

        usrReq_url = '/api/transactions/references';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push();
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdl.requestId) {
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onGetfilterReferenceRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected getTransactionOverviewForExport(isReorder = false) {

        let subViewModel = this.listTemplate.getViewModelForRequest();

        let formReq_url: string;
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        if( "getReportDataForExport" in this.XHRHdls ){
            this.XHRHdls["getReportDataForExport" ].cancelAndReset();
        }

        formReq_url = '/api/accounting/getTransactionsOverviewForExport/';
        this.XHRHdls['getReportDataForExport'] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdls['getReportDataForExport'].onReadyStateFunction = this.onFilterRequestReturnExport;
        this.XHRHdls['getReportDataForExport'].execute();

    }


    protected onGetfilterReferenceRequestReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    obj.listTemplate.validationsList.clearMessages();
                    obj.updateReferenceList(responseParsed.data);

                    obj.updateViewModelFromPath();
                    obj.getSearchPresetsListData();

                    obj.filterList()
                } else if (req.request.status == "423") {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    let url: string;
                    if (obj.getVnAppZone().app.params.idBrand) {
                        url = '/' + obj.getVnAppZone().app.params.idBrand + '/home';
                    } else {
                        url = '/';
                    }
                    page.redirect(url);
                } else {

                    obj.onUpdateError(req.request.status, responseParsed);
                }

            }
        }
    }

    public getUserBrands(): Array<{id: number, name: string}> {

        let vnApp = this.getVnAppZone().app;

        return vnApp.loggedUser.user.brands;
    }

    protected updateReferenceList(response: any) {

        this.listTemplate.setPaymentRoleFilterItems(response.roles);
        this.listTemplate.setTransactionAccounts(response.accounts)
        this.listTemplate.setPaymentCurrencyFilterItems(response.currencies);
        this.listTemplate.setPaymentDates(response.paymentDates);
        this.listTemplate.setPaymentMethods(response.paymentMethods);
        this.listTemplate.setBrandFilterItems(this.getUserBrands()); //doesnt work
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected filterSimpleOnChange() {
        this.filterList();
    }

    protected paymentListReorder() {
        this.filterList();
    }

    protected filterDateOnChange() {
        this.filterList();
    }

    protected filterList(isReorder = false) {

        let elementForLoading = this.listTemplate.builtTemplate
            .children.namedItem("main-container")
            .children.namedItem("list-results");

        const tableEl = (elementForLoading as HTMLElement).getElementsByTagName('table')[0];
        if (tableEl) {
            elementForLoading = tableEl as any;
        }

        if (this.XHRHdls['getReportDataCount']) {
            this.XHRHdls['getReportDataCount'].cancelAndReset();
        }
        if (this.XHRHdls['getReportDataBreakout']) {
            this.XHRHdls['getReportDataBreakout'].cancelAndReset();
        }
        if (this.XHRHdls['getReportDataForExport']) {
            this.XHRHdls['getReportDataForExport'].cancelAndReset();
        }
        // Reset returned counter for the new batch
        this.nbReturnedQueries = 0;

        this.loadingIn(elementForLoading);
        const subViewModel = this.listTemplate.getViewModelForRequest();

        let formReq_url: string;
        const formReq_params: string[][] = [];

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.queryStartTime = new Date().getTime();

        if (isReorder)
        {
            this.nbQueries = 1;
        }
        else {
            this.nbQueries = 3;
        }

        if (subViewModel.filters.paymentDates().length != 0)
        {

            formReq_url = '/api/accounting/getTransactionsOverview/';

            const subViewModel = this.listTemplate.getViewModelForRequest();
            this.sendFilterCall(
                formReq_url,
                subViewModel,
                this.onFilterRequestReturn,
                XMLHttpRequestHandler_requestType.GET,
                'accounting_report_by_user'
            );


            if (!isReorder)
            {
                formReq_url = '/api/accounting/getTransactionsOverviewCount/';
                this.XHRHdls['getReportDataCount'] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
                this.XHRHdls['getReportDataCount'].onReadyStateFunction = this.onFilterRequestReturnCount;
                this.XHRHdls['getReportDataCount'].execute();

                formReq_url = '/api/accounting/getTransactionsOverviewBreakout/';
                this.XHRHdls['getReportDataBreakout'] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
                this.XHRHdls['getReportDataBreakout'].onReadyStateFunction = this.onFilterRequestReturnBreakout;
                this.XHRHdls['getReportDataBreakout'].execute();
            }

        }
        else {
            this.listTemplate.setResultNbResultsAndPages(0, 0);
            this.listTemplate.setResultExecutionTime(0);
            this.listTemplate.setReportResultsForExport([]);
            this.listTemplate.setReportResults([]);
            this.listTemplate.setBreakoutData([]);

            this.loadingOut(elementForLoading);
            return;
        }

    }

    protected onFilterRequestReturn(req, obj) {

        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);

                obj.updateList(responseParsed);
            });
        }

    }
    protected onFilterRequestReturnExport(req, obj) {

        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);
                obj.updateExportData(responseParsed);
                obj.listTemplate.exportToCSV()
            });
        }
    }

    protected onFilterRequestReturnBreakout(req, obj) {

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateBreakout(responseParsed);
            });
        }
    }

    protected onFilterRequestReturnCount(req, obj) {

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateItemCount(responseParsed);

            });
        }

    }

    protected onLastRequestReturn()
    {

        if (this.nbReturnedQueries == this.nbQueries){

            let el: any = this.listTemplate.builtTemplate.children.namedItem("main-container").children.namedItem("list-results");
            const table = (el as HTMLElement).getElementsByTagName('table')[0];
            if (table) {
                el = table as any;
            }
            this.loadingOut(el);
            this.listTemplate.setResultExecutionTime(this.getMaxExecTime());
            this.nbReturnedQueries = 0;
        }
    }

    protected getMaxExecTime()
    {
        return Math.round((new Date().getTime() - this.queryStartTime )/1000*100)/100;
    }

    protected updateBreakout(responseParsed) {
        this.nbReturnedQueries++;
        this.listTemplate.setBreakoutData(responseParsed);
        this.onLastRequestReturn();
    }

    protected updateItemCount(responseParsed) {
        this.nbReturnedQueries++;
        this.listTemplate.setResultNbResultsAndPages(responseParsed.totalCount, responseParsed.totalPage );
        this.viewModel.list.pagination.itemCount(responseParsed.totalCount);//Update the Paginator
        this.onLastRequestReturn();

    }

    protected updateList(responseParsed) {
        this.nbReturnedQueries++;
        this.listTemplate.setReportResults(responseParsed.data);

        this.onLastRequestReturn();
    }

    protected updateExportData(responseParsed) {
        this.nbReturnedQueries++;
        this.listTemplate.setReportResultsForExport(responseParsed);
        this.onLastRequestReturn();

    }

    public exportToCSV(reportResults: string[][], breakout: number[], fname: string ){

        let data = [];

        //row titles in Excel spreadsheet
        let titles = [ "Name ( loginName )",  "Payment Method ID", "Payment Method", "Role", "Currency", "User Total", "Total", "Commission",     "Performance",     "Consulting Base",    "Bonuses",  "Tips", "Hosting", "Training", "Adjustments", "Lead Bonus", "Benefits", "Expenses", "Promotion" ]
        //Names/keys in json object
        let keys =   [ "uniqueName",          "email", "paymentMethod", "role", "currency", "sumUser", "groupCost",    "commissionCost", "performanceCost", "consultingBaseCost", "bonusCost", "tipsCost", "hostingCost", "trainingCost", "adjustmentsCost", "leadBonusCost", "benefitsCost", "expensesCost", "promotionCost" ]
        let titleRow = {};
        let row;
        titles.forEach( t => { titleRow[t] = '' })
        data.push(titleRow);

        for (let item of reportResults) {

            row = {};

            for (let i = 0; i < titles.length; i++) {
                row[titles[i]] = item[keys[i]];
            }

            data.push(row);
        }

        //push empty row
        data.push(titleRow);

        //Push Totals Row
        row = {"Name ( loginName )": "Totals", "Payment Method ID": "", "Payment Method": "", "Role": "", "Currency":"", "User Total":"", };


        let breakoutTitles = ["Total", "Commission",     "Performance",     "Consulting Base",    "Bonuses",  "Tips", "Hosting", "Training", "Adjustments", "Lead Bonus", "Benefits", "Expenses", "Promotion" ]

        let breakoutKeys = [ "grandTotal", "commissionCost", "performanceCost", "consultingBaseCost", "bonusCost", "tipsCost", "hostingCost", "trainingCost", "adjustmentsCost", "leadBonusCost", "benefitsCost", "expensesCost", "promotionCost" ];

        for (let i = 0; i < breakoutTitles.length; i++) {
            row[breakoutTitles[i]] = breakout[breakoutKeys[i]];
        }

        data.push(row);

        downloadCSV({filename: fname, data: data});
    }

    protected filterDropdownOnChange() {
        // on keywords filtering, always set the page back to 1.
        this.filterList()
    }

    protected onUpdateError(requestStatus: any, responseParsed): void {
        let msg = "error: while obtaining the data - (" + requestStatus + ")";
        this.viewModel.list.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
        window.scrollTo(0, 0);
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        this.XHRHdlsKeys.forEach( k => {
            this.XHRHdls[k].cancelAndReset();
        })
    }

    protected getUsersSuggestion(keyword) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}, isForAccountingReport: true};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.users) {
                    obj.listTemplate.setUsers(responseParsed.data.users);
                }
            });
        }
    }

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetArticles
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.listTemplate.addCreatedPresetToList(response);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPresetArticles
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected setDefaultStatusFilters(){
        this.listTemplate.setDefaults();
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){
        this.listTemplate.setViewModelFromRequest(filters);
        this.filterList();
    }
}




// WEBPACK FOOTER //
// ./js/modules/accounting_report_by_user.ts